import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=2026a570"
import script from "./VTable.vue?vue&type=script&lang=js"
export * from "./VTable.vue?vue&type=script&lang=js"
import style0 from "./VTable.vue?vue&type=style&index=0&id=2026a570&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports